
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip-pick-answer-w)","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#fff"}},[_c('path',{attrs:{"d":"M23 8.014c-3.836 0-6.972 3.136-6.972 6.973 0 3.836 3.136 6.972 6.972 6.972 3.837 0 6.973-3.136 6.973-6.972 0-3.837-3.136-6.973-6.973-6.973zm3.157 8.886a.879.879 0 11-1.243 1.243L23 16.229l-1.913 1.914a.879.879 0 11-1.243-1.243l1.914-1.913-1.914-1.914a.879.879 0 111.243-1.243L23 13.744l1.914-1.914a.879.879 0 111.243 1.243l-1.914 1.914 1.914 1.913z","fill-opacity":".65"}}),_c('path',{attrs:{"d":"M7.468 16.972a.879.879 0 01-1.243 0l-1.86-1.86a.879.879 0 011.243-1.243l1.239 1.239 5.048-5.048a6.952 6.952 0 00-4.922-2.045 6.952 6.952 0 00-4.925 2.047A6.952 6.952 0 000 14.988c0 1.918.784 3.661 2.047 4.925a6.952 6.952 0 004.926 2.047 6.952 6.952 0 004.925-2.047 6.951 6.951 0 002.047-4.925 6.917 6.917 0 00-.964-3.529l-5.513 5.513z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip-pick-answer-w"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h30v30H0z"}})])])])
          )
        }
      }
    